import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { getSettings } from "@/lib/api";
import { PACKAGES, CONTACT } from "@/data/site";

const DEFAULTS = {
  packages: PACKAGES,
  contact: CONTACT,
  serviceArea: ["McAllen", "Mercedes", "Edinburg", "Pharr", "Weslaco", "Brownsville", "Harlingen"],
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const s = await getSettings();
      setSettings({
        packages: s.packages || DEFAULTS.packages,
        contact: { ...DEFAULTS.contact, ...(s.contact || {}) },
        serviceArea: s.serviceArea || DEFAULTS.serviceArea,
      });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
